// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host{display:inline-block}:host([hidden]){display:none}.space-logo{display:flex;align-items:center;justify-content:center;background:#2540ff;border-radius:16px;box-shadow:0px 10px 15px -3px rgba(37,64,255,0.2),0px 4px 6px -4px rgba(37,64,255,0.2)}.space-logo img{width:100%;height:100%;object-fit:contain}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
